import React from "react"
import { useTranslation } from 'react-i18next'
import Select from 'react-select'

import { expenseAccountName, groupAccountsByPos } from './financeUtils'

// cashboxes and POS safes grouped by POS (the POS name is the group heading), each with its icon;
// the selected value is "Касса 1 (Магазин 1)"
function AccountSelect({ options, value, onChange, isLoading, emptyMessage = 'FO_NO_OPEN_SHIFTS' }) {
	const { t } = useTranslation()

	return (
		<Select
			options={groupAccountsByPos(options)}
			value={value || null}
			onChange={onChange}
			isLoading={isLoading}
			placeholder=""
			classNamePrefix="fo-account-select"
			noOptionsMessage={() => t(emptyMessage)}
			getOptionLabel={(option) => [expenseAccountName(option, t), option.posName].filter(Boolean).join(' ')}
			getOptionValue={(option) => option.key ?? option.cashboxId}
			formatOptionLabel={(option, { context }) => context === 'menu'
				? <span className="fo-account-option">
					<i className={'uil ' + (option.sourceType === 'SAFE' ? 'uil-wallet' : 'uil-monitor')}></i>
					{expenseAccountName(option, t)}
				</span>
				: <>
					{expenseAccountName(option, t)}
					{option.posName &&
						<span className="text-muted"> ({option.posName})</span>
					}
				</>
			}
		/>
	)
}

export default AccountSelect
